export default {"src":"/_next/static/media/gallery_icon_blue.dac795d2.svg","height":26,"width":18};